/** @format */

import React from 'react';
import { createRoot } from 'react-dom/client';
import TimelineSlider from './timeline-slider';

/**
 * Build Varian Timeline.
 */
export const timeline = () => {
  const timelineContainer = document.getElementById('varian-timeline-slider');
  if (timelineContainer !== null) {
    const root = createRoot(timelineContainer);
    root.render(React.createElement(TimelineSlider));
  }
};
